import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=710f6877&"
import script from "./Tab.vue?vue&type=script&lang=js&"
export * from "./Tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('710f6877', component.options)
    } else {
      api.reload('710f6877', component.options)
    }
    module.hot.accept("./Tab.vue?vue&type=template&id=710f6877&", function () {
      api.rerender('710f6877', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/EquiposEnTerreno/components/Tab.vue"
export default component.exports